import { render, staticRenderFns } from "./uflist.vue?vue&type=template&id=7994933a&scoped=true"
import script from "./uflist.vue?vue&type=script&lang=js"
export * from "./uflist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7994933a",
  null
  
)

export default component.exports